<template>
  <!-- <can I="view" a="activities"> -->
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <h4>{{ $t('global.audit_logs_list_title') }}</h4>
        <div v-if="spinners.contentIsLoading" class="text-center">
          <b-spinner type="grow" variant="primary" />
        </div>
        <div v-else>
          <b-row>
            <b-col cols="12">
              <b-table class="table-sm text-center" responsive outlined hover head-variant="light" :fields="tableFields"
                :items="tableItems" @row-clicked="(item, index, event) => item._showDetails = !item._showDetails">
                <template v-slot:cell(created_at)="{ value }">{{ momentf(value) }}</template>
                <template v-slot:cell(updated_at)="{ value }">{{ momentf(value) }}</template>
                <template #row-details="row">
                  <b-card>
                    <vue-json-pretty :data="row.item.properties" />
                    <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
                  </b-card>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <!--Paginator-->
            <b-col cols="12" v-if="tableItems.length">
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" />
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
  <!-- </can> -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import VueJsonPretty from 'vue-json-pretty';
import VT from '@/store/types';
import statuses from '@/store/statuses';
import 'vue-json-pretty/lib/styles.css';

export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  data() {
    return {
      spinners: {
        contentIsLoading: true,
      },
      tableFields: [
        { key: 'id', label: this.$t('global.id') },
        { key: 'log_name', label: this.$dt('audit_logs.log_name', 'Log Name') },
        { key: 'description', label: this.$t('global.description') },
        { key: 'subject_id', label: this.$t('global.subject_id') },
        { key: 'subject_type', label: this.$t('global.subject_type') },
        { key: 'causer_id', label: this.$t('global.causer_id') },
        { key: 'causer_type', label: this.$t('global.causer_type') },
        { key: 'created_at', label: this.$t('global.created_at') },
        { key: 'updated_at', label: this.$t('global.updated_at') },
        { key: 'batch_uuid', label: this.$dt('audit_logs.batch_uuid', 'Batch') }

      ],
      tableItems: []
    };
  },
  components: {
    VueJsonPretty,
    Pagination,
  },
  computed: {
    ...mapGetters('AuditLogs', [
      'auditLogsList'
    ]),
    listPaginator() {
      return this.auditLogsList.data.meta;
    },
    list() {
      return this.auditLogsList;
    },
  },
  watch: {
    page: 'getData',
    listPaginator: {
      handler: function () {
        if (this.listPaginator && this.listPaginator.last_page < this.page) {
          this.onPageChange(this.listPaginator.last_page);
        }
      },
      deep: true
    },
    list: {
      handler: function () {
        if (this.list['status'] === statuses.LOADED) {
          this.tableItems = this.list.data.data.map((e) => ({
            ...e,
            _showDetails: false
          })) || [];
          this.spinners.contentIsLoading = false;
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('AuditLogs', [
      VT.AUDIT_LOGS_LIST,
    ]),
    getData() {
      this.AUDIT_LOGS_LIST(this.page);
    },
    onPageChange(page) {
      if (!page) {
        page = this.page;
      }
      if (page !== this.page) {
        this.$router.push({ name: 'AuditLogs', params: { page } });
      }
    },
  }
};

</script>

<style scoped></style>
